import React from "react";
import {Card as KendoCard, CardBody, CardTitle} from "@progress/kendo-react-layout";

export const Card = ({type = "default", title, children, style}) => {

    return (
        <KendoCard type={type} style={style}>
            <CardBody>
                <CardTitle >{title}</CardTitle>
                {children}
            </CardBody>
        </KendoCard>
    )
}